import {
    LOAD_SUB_ANSWERS_SUCCESS, RESET_SUB_ANSWERS, REORDER_SUB_ANSWERS_SUCCESS
} from '../../../actions/types';

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch(action.type) {
        case LOAD_SUB_ANSWERS_SUCCESS:
            return action.payload;
        case REORDER_SUB_ANSWERS_SUCCESS:
            return action.payload;
        case RESET_SUB_ANSWERS:
            return INITIAL_STATE;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/restaurants/posmenu/SubAnswersReducer.js